


import React, { useEffect, useState } from "react";

import Navbar2 from "../components2/Navbar";
import Sidebar2 from "../components2/Sidebar.js";
import {useNavigate, useLocation} from 'react-router-dom';
import { useScrollTrigger } from "@mui/material";

export default function TeacherDashboard() {
  const navigate = useNavigate();
  let [random,setRandom]=useState();
useEffect(()=>{
  setRandom(Math.random()*1000)

},[])
  const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' }
  ]
  let arr=[   {
    title: "jasklfj",
    image: "https://pgc.edu/wp-content/uploads/2021/05/How-to-Become-a-Special-Education-Teacher.jpg",
    status: "In Home",
  },
  {
    title: "jasklfj",
    image:
      "https://www.collinsdictionary.com/images/full/teacher_81762259.jpg",
    status: "In Shop",
  },
  {
    title: "jasklfj",
    image:
      "https://i0.wp.com/academiamag.com/wp-content/uploads/2022/02/professional-development-tools-for-teachers.jpg?fit=820%2C460&ssl=1",
    status: "In Shop",
  },
  {
    title: "jasklfj",
    image:
      "https://api.teach.org/sites/default/files/2022-03/Homepage_Hero_Illustration.png",
    status: "In Home",
  },   {
    title: "jasklfj",
    image: "https://pgc.edu/wp-content/uploads/2021/05/How-to-Become-a-Special-Education-Teacher.jpg",
    status: "In Home",
  },
  {
    title: "jasklfj",
    image:
      "https://www.collinsdictionary.com/images/full/teacher_81762259.jpg",
    status: "In Shop",
  },
  {
    title: "jasklfj",
    image:
      "https://i0.wp.com/academiamag.com/wp-content/uploads/2022/02/professional-development-tools-for-teachers.jpg?fit=820%2C460&ssl=1",
    status: "In Shop",
  },
  {
    title: "jasklfj",
    image:
      "https://api.teach.org/sites/default/files/2022-03/Homepage_Hero_Illustration.png",
    status: "In Home",
  },   {
    title: "jasklfj",
    image: "https://pgc.edu/wp-content/uploads/2021/05/How-to-Become-a-Special-Education-Teacher.jpg",
    status: "In Home",
  },
  {
    title: "jasklfj",
    image:
      "https://www.collinsdictionary.com/images/full/teacher_81762259.jpg",
    status: "In Shop",
  },
  {
    title: "jasklfj",
    image:
      "https://i0.wp.com/academiamag.com/wp-content/uploads/2022/02/professional-development-tools-for-teachers.jpg?fit=820%2C460&ssl=1",
    status: "In Shop",
  },
  {
    title: "jasklfj",
    image:
      "https://api.teach.org/sites/default/files/2022-03/Homepage_Hero_Illustration.png",
    status: "In Home",
  },   {
    title: "jasklfj",
    image: "https://pgc.edu/wp-content/uploads/2021/05/How-to-Become-a-Special-Education-Teacher.jpg",
    status: "In Home",
  },
  {
    title: "jasklfj",
    image:
      "https://www.collinsdictionary.com/images/full/teacher_81762259.jpg",
    status: "In Shop",
  },
  {
    title: "jasklfj",
    image:
      "https://i0.wp.com/academiamag.com/wp-content/uploads/2022/02/professional-development-tools-for-teachers.jpg?fit=820%2C460&ssl=1",
    status: "In Shop",
  },
  {
    title: "jasklfj",
    image:
      "https://api.teach.org/sites/default/files/2022-03/Homepage_Hero_Illustration.png",
    status: "In Home",
  },]



  return (
    localStorage.getItem('teacher_uid') !== null?

    <>
      <Sidebar2 />
      <div className="relative md:ml-64 bg-blueGray-100">
        <Navbar2 />
        {/* Header */}
        <div className="relative bg-pink-600 md:pt-12 pb-10">
          <div className="px-4 md:px-10 mx-auto w-full ml-2 d-flex align-items-center justify-content-center flex-column">
           <div style={{height:38}}>

           </div>
            <div className="d-flex align-items-center flex-column pb-9">
              <h1 className="text-white font-semibold text-3xl	 text-center">
               List Of All Request
              </h1>
            </div>
          </div>
        </div>
        <table>
  <thead>
    <tr>
      <th scope="col">Account</th>
      <th scope="col">Date</th>
      <th scope="col">Amount</th>
      <th scope="col">Period</th>
  

    </tr>
  </thead>
  <tbody>
    <tr>
      <td data-label="Sr#">Visa - 3412</td>
      <td data-label="Date">04/01/2016</td>
      <td data-label="Amount">$1,190</td>
      <td data-label="Period">03/01/2016 - 03/31/2016</td>
  

    </tr>



    <tr>
      <td data-label="Sr#">Visa - 3412</td>
      <td data-label="Date">04/01/2016</td>
      <td data-label="Amount">$1,190</td>
      <td data-label="Period">03/01/2016 - 03/31/2016</td>
   

    </tr>

  </tbody>
</table> 
      </div>



      
    </>
    :
    navigate('/Login')

  );
}
